import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

const documentTypeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

const documentSeriesSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

const defaultWarehouseSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

export const getDocumentSeriesTypesSchema = z.array(
  baseObjectSchema.extend({
    documentTypeID: z.string(),
    documentSeriesID: z.string(),
    defaultWarehouseID: z.string().optional(),
    documentType: documentTypeSchema,
    documentSeries: documentSeriesSchema,
    defaultWarehouse: defaultWarehouseSchema.optional(),
    isDefault: z.number(),
    sequenceFormat: z.string().optional(),
  })
);

export type GetDocumentSeriesTypesResponse = z.infer<typeof getDocumentSeriesTypesSchema>;
